<template>
  <span
    class="loader-overlay"
  >
    <span class="loader-img" />
  </span>
</template>

<script>
export default {
  name: 'Loading',
};
</script>
